import { Card, CardContent, TextField, Typography } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import * as Yup from 'yup';
import { AppState } from '../../../state/configureStore';
import {
  clearProgram,
  createProgram,
  fetchProgram,
  Program,
  ProgramState,
  updateProgram,
} from '../../../state/program';
import { FixedPositionButtons } from '../../components';

import useStyles from './programForm.style';

const ProgramSchema = Yup.object().shape({
  name: Yup.string().strict(true).trim().required('Name is required'),
  externalId: Yup.string().strict(true).trim().required('ExternalId is required'),
  isUseNpd: Yup.boolean(),
  isHighPriority: Yup.boolean(),
  // typeOfBusiness: Yup.string()
  //   .strict(true)
  //   .trim()
  //   .required('Type of Business is required'),
});

interface ProgramFormRouteParamsProps {
  id: string;
}

interface ProgramFormProps extends RouteComponentProps<ProgramFormRouteParamsProps> {}

const ProgramForm: React.FC<ProgramFormProps> = (props) => {
  const { match, history } = props;
  const {
    params: { id: paramsId },
  } = match;
  const classes = useStyles();
  const {
    item: {
      name = '',
      externalId = '',
      id = 0,
      isUseNpd = false,
      isHighPriority = false,
      typeOfBusiness = '',
      inspectionLevel = '',
      standardChart = '',
      standardChartQty = 0,
      specialNote = '',
    },
  } = useSelector<AppState, ProgramState>((state) => state.program);
  const dispatch = useDispatch();

  const redirectToProgramList = () => {
    history.push('/settings/programs');
  };

  const handleSubmit = (values: Program, actions: FormikHelpers<any>) => {
    if (paramsId) {
      dispatch(updateProgram({ values, history }));
    } else {
      dispatch(createProgram({ values, history }));
    }
    actions.setSubmitting(false);
  };

  useEffect(() => {
    if (paramsId) {
      dispatch(fetchProgram(+paramsId));
    } else {
      dispatch(clearProgram());
    }

    return function cleanUp() {
      dispatch(clearProgram());
    };
  }, [paramsId, dispatch]);

  return (
    <Card className={classes.root}>
      <Formik
        enableReinitialize={true}
        initialValues={{
          name,
          externalId,
          id,
          isUseNpd,
          isHighPriority,
          typeOfBusiness,
          inspectionLevel,
          standardChart,
          standardChartQty,
          specialNote,
        }}
        validationSchema={ProgramSchema}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, errors, touched, submitForm }) => {
          return (
            <Form>
              <Typography variant="h4" className={classes.title}>
                {paramsId === undefined ? `New Program` : `Update Program`}
              </Typography>
              <CardContent>
                <Typography variant="body2">Name</Typography>
                <TextField
                  name="name"
                  type="input"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  value={values.name}
                  style={{ backgroundColor: '#f5f5f5' }}
                  className={classes.customInput}
                  size="small"
                  // onChange={handleChange}
                  // error={!!errors.name && !!touched.name}
                  // helperText={errors.name}
                  // disabled
                />

                <Typography variant="body2">Inspection Level</Typography>
                <TextField
                  name="inspectionLevel"
                  type="input"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  value={values.inspectionLevel ?? ''}
                  className={classes.customInput}
                  onChange={handleChange}
                />

                <Typography variant="body2">Standard Chart</Typography>
                <TextField
                  name="standardChart"
                  type="input"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  value={values.standardChart ?? ''}
                  className={classes.customInput}
                  onChange={handleChange}
                />
                <Typography variant="body2">Standard Chart Qty.</Typography>
                <TextField
                  name="standardChartQty"
                  type="number"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  value={values.standardChartQty ?? ''}
                  className={classes.customInput}
                  onChange={handleChange}
                />

                <Typography variant="body2">Special Note</Typography>
                <TextField
                  name="specialNote"
                  type="input"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  value={values.specialNote ?? ''}
                  className={classes.customInput}
                  onChange={handleChange}
                />
                {/* <TextField
                  name="externalId"
                  type="input"
                  label="ExternalId"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  value={values.externalId}
                  onChange={handleChange}
                  error={!!errors.externalId && !!touched.externalId}
                  helperText={errors.externalId}
                  disabled
                /> */}

                {/* <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isUseNpd"
                        checked={values.isUseNpd}
                        onChange={handleChange}
                        value={values.isUseNpd}
                      />
                    }
                    label="Is Use NPD"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isHighPriority"
                        checked={values.isHighPriority!}
                        onChange={handleChange}
                        value={values.isHighPriority}
                      />
                    }
                    label="Is High Priority"
                  />
                </FormGroup>  */}
              </CardContent>
              <FixedPositionButtons
                actions={[
                  {
                    name: paramsId === undefined ? `Create` : `Update`,
                    onClick: () => {
                      submitForm();
                    },
                    color: 'primary' as 'primary',
                    disabled: false,
                    icon: 'save',
                  },
                  {
                    name: 'CANCEL',
                    onClick: redirectToProgramList,
                    color: 'default' as 'default',
                    disabled: false,
                  },
                ]}
                open
              />
            </Form>
          );
        }}
      </Formik>
    </Card>
  );
};

export default ProgramForm;
